export default __webpack_public_path__ + "static/media/img1.d36879e9.png";